// extracted by mini-css-extract-plugin
export var actions = "_w-0";
export var actionsContainer = "_w-6";
export var border = "_w-1";
export var childFullHeight = "_w-d";
export var collapse = "_w-2";
export var content = "_w-8";
export var contentChild = "_w-c";
export var fullscreen = "_w-a";
export var headerContainer = "_w-3";
export var headerRow = "_w-5";
export var hidePadding = "_w-9";
export var noScrollX = "_w-e";
export var noScrollY = "_w-f";
export var optOutTopPadding = "_w-b";
export var pagePadding = "_w-7";
export var profile = "_w-g";
export var profileContainer = "_w-h";
export var profileImage = "_w-i";
export var profileMain = "_w-j";
export var profileSubtitle = "_w-l";
export var profileTitle = "_w-k";
export var tabsWrapper = "_w-4";
export var title = "_w-m";